<template>
  <div class="companyView">
    <div class="banner">
      <div class="title">
        <div>{{ C.banner }}</div>
      </div>
    </div>
    <div class="page1">
      <div class="img">
        <img src="../../static/img/company/pexels.png" alt="" />
      </div>
      <div class="right">
        <div class="title">
          {{ C.summarize }}
        </div>
        <div class="text">
          <div class="text_in" v-for="(e, i) in C.summarize_text" :key="i">
            {{ e }}
          </div>
        </div>
      </div>
      <div class="bot">
        <div>
          <div class="num">10<span>+</span></div>
          <div>
            <span class="bold">{{ C.experience }}</span>
          </div>
        </div>
        <div>
          <div class="num">200<span>+</span></div>
          <div>
            <span class="bold">{{ C.countries }}</span>
          </div>
        </div>
        <div>
          <div class="num">100<span>+</span></div>
          <div>
            <span class="bold">{{ C.industries }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="page2">
      <div class="title">
        <span>{{ C.qualified }}</span>
      </div>
      <div class="zs">
        <swiper :options="goodmanuSaleOptions">
          <swiper-slide v-for="(item, index) in 12" :key="index">
            <div class="swC"></div>
          </swiper-slide>
        </swiper>
      </div>
    </div> -->
    <div class="page2">
      <img style="width: 100%;text-align: center;" src="../../static/img/company/page33.png" alt="" />
    </div>
    <div class="page3">
      <div class="top">
        <div class="title">
          {{ C.core }}
        </div>
        <div class="text">
          {{ C.culture.title }}
        </div>

        <div class="bot" v-if="C.culture.arr">
          <div v-for="(e, i) in C.culture.arr" :key="i" v-html="e"></div>
        </div>
      </div>
      <div class="bot">
        <div class="title">
          {{ C.join }}
        </div>
        <hr />
        <div class="text">
          {{ C.text }}
        </div>
        <div class="copy" style="text-align:center">
          <div ref="copyele" style="display:inline-block">
            eileen.song@hitransgroup.com
          </div>
          <div class="pointer" style="display:inline-block" @click="copyContent">
            {{ C.copy }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import text from "../../static/data/text";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import moveArr from "../../static/movedata/about.js";
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      lan: "cn",
      allTimeline: null,
      goodmanuSaleOptions: {
        loop: true,
        autoplay: true,
        slidesPerView: 4
      }
    };
  },
  computed: {
    C() {
      return text[this.lan]["company"];
    }
  },
  mounted() {
    if (document.body.style.zoom > 0.95) {
      window.addEventListener("scroll", this.scrollToTop, true);
      this.initaniE();
    }
  },
  methods: {
    initaniE() {
      this.allTimeline = new TimelineMax({ paused: true });
      let scrollAnimationObj = moveArr;
      for (let i = 0; i < scrollAnimationObj.length; i++) {
        let bwTimeline = new TimelineMax({
          delay: scrollAnimationObj[i].distancetop / 4654
        });
        let bwTween = TweenMax.fromTo(
          scrollAnimationObj[i].ele,

          scrollAnimationObj[i].distancebottom / 4654,
          scrollAnimationObj[i].from,
          scrollAnimationObj[i].to
        );
        bwTimeline.add(bwTween, 0);
        this.allTimeline.add(bwTimeline, 0);
      }
    },
    scrollToTop() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      console.log(scrollTop);
      this.allTimeline.seek(scrollTop / 4654);
    },
    copyContent() {
      let inputElement = document.createElement("input");
      var content = null;
      content = this.$refs.copyele.innerText;
      inputElement.type = "text";
      inputElement.value = content;
      document.body.appendChild(inputElement);
      // 选择增加的input元素
      let that = this;
      inputElement.select();
      if (document.execCommand("Copy", "false", null)) {
        // 如果复制成功
        that.$message.success("复制成功");
      }
      document.body.removeChild(inputElement);
    }
  }
};
</script>

<style scoped>
.banner {
  height: 565px;
  position: relative;
  overflow-x: hidden;
  line-height: 0;
  background: url("/static/img/company/banner.png") no-repeat fixed;
}

.banner .title {
  text-align: center;
  margin: 225px auto 0;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  padding: 0 660px;
  transition: all 0.5s;
}

.banner .title div {
  padding: 74px 0;
  border-top: 2px solid rgba(255, 255, 255, 0.3);
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 87px;
}

.page1 {
  padding: 98px 289px 0 153px;
  position: relative;
  /* display: flex; */
  margin-bottom: 50px;
}

.page1::before {
  content: "";
  width: 502px;
  height: 923px;
  background: #3472ef;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.page1 .img {
  float: left;
  transition: all 0.5s;
}

.page1 .right {
  /* float: left; */
  margin-left: 606px;
  margin-top: 40px;
}

.page1 .right .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 87px;
  transition: all 0.5s;
}

.page1 .right .text {
  margin-top: 40px;
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 47px;

  transition: all 0.5s;
}

.page1 .right .text .text_in {
  margin-bottom: 40px;
}

.page1 .right .text .text_in:last-of-type {
  margin-bottom: 0;
}

.page1 .bot {
  display: flex;
  padding-left: 100px;
  justify-content: space-between;
  margin-top: 83px;
  transition: all 0.5s;
}

.page1 .bot>div {
  display: flex;
  vertical-align: bottom;
  align-items: baseline;
}

.page1 .bot .num {
  font-size: 165px;
  font-family: Teko-Regular, Teko;
  letter-spacing: -10px;
  margin-right: 20px;
  font-weight: 400;
  color: #3472ef;
}

.page1 .bot .num span {
  font-size: 34px;
}

.page1 .bot .num+div {
  margin-left: 21px;
}

.page1 .bot .num+div span {
  display: inline-block;
  margin-top: 155px;
}

/* page2 */
.page2 {
  padding: 149px 0;width: 85%;
}

.page2 .title {
  background: url("../../static/img/company/page33.png") no-repeat left center;
  height: 1600px;
  transition: all 0.5s;
  background-size: cover;
  background-position: center;
}

.page2 .title span {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 327px;
  margin-left: 295px;
}

.page2 .zs {
  margin-top: 56px;
  display: flex;
  justify-content: space-between;
  padding: 0 286px;
  transition: all 0.5s;
}

.page2 .zs .swC {
  width: 315px;
  height: 447px;
  background: url("../../static/img/company/zs.png") no-repeat center center;
  background-size: 315px 447px;
}

/* page3 */
.page3 {
  position: relative;
  padding-top: 91px;
}

.page3::before {
  content: "";
  width: 1633px;
  height: 741px;
  background: #3472ef;
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

.page3 .top {
  width: 1047px;
  height: 717px;
  background: url("../../static/img/company/page3.png") no-repeat center center;
  background-size: 1633px 866px;
  margin-left: 76px;
  padding: 149px 375px 0 211px;
  transition: all 0.5s;
}

.page3 .top .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  line-height: 87px;
}

.page3 .top .text {
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 47px;
  margin-top: 75px;
}

.page3 .top .bot {
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 47px;
  margin-top: 59px;
}

.page3 .bot {
  margin-top: 149px;
}

.page3 .bot .title {
  font-size: 65px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #000000;
  line-height: 87px;
  text-align: center;
}

.page3 .bot hr {
  width: 1346px;
  background: #3472ef;
  height: 1px;
  margin: 73px auto 0;
}

.page3 .bot .text {
  width: 872px;
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  line-height: 47px;
  text-align: center;
  margin: 52px auto 0;
  transition: all 0.5s;
}

.page3 .bot .copy {
  margin-top: 52px;
  position: relative;
  margin-bottom: 149px;
  transition: all 0.5s;
}

.page3 .bot .copy div:nth-of-type(1) {
  /* width: 370px; */
  height: 73px;
  line-height: 73px;
  border-radius: 37px;
  background: #ebf1ff;
  margin: 0 auto;
  text-indent: 70px;
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  padding-right: 110px;
}

.page3 .bot .copy div:nth-of-type(2) {
  /* width: 166px; */
  padding: 0 50px;
  margin-left: -101px;
  height: 73px;
  background: #3472ef;
  border-radius: 37px 37px 37px 37px;
  opacity: 1;
  line-height: 73px;
  text-align: center;
  font-size: 28px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  /* position: absolute; */
  right: 700px;
  top: 0;
}

.pointer {
  cursor: pointer;
}

.bold {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/company.vue